import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';

@Component({
  selector: 'app-coverage-type-field',
  templateUrl: './coverage-type-field.component.html',
  styleUrls: ['./coverage-type-field.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class CoverageTypeFieldComponent implements OnInit {
  @Input() lob: string;
  @Input('required') isRequired = false;
  @Input('multiple') isMultiSelect:boolean = true;

  form: FormGroup;
  constructor(private ctrlContainer: FormGroupDirective){};

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;

    if (this.isRequired) {
      this.form.addControl('coverage_type', new FormControl([], Validators.required));
    } else {
      this.form.addControl('coverage_type', new FormControl([]));
    }

    this.form.controls['coverage_type'].valueChanges.subscribe((val: any) => {
      if (val == null) {
        this.form.patchValue({ 'coverage_type': [] });
      }
    });
  }
  selectionChange(event:any){
    if(!this.isMultiSelect && event.isUserInput && event.source.selected){
      this.form.controls['coverage_type'].setValue([event.source.value]);
    }
  }

  ngOnDestroy(): void {
    this.form.removeControl('coverage_type');
  }
}
